<template>
  <footer>
    <div class="footer-top">
      <div class="content-wrapper">
        <div class="top__bottom">
          <div class="box">
            <h3>Allegro</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  href="https://magazyn.allegro.pl/3333-serwis-allegro-to-nasz-sposob-na-wasze-szybkie-i-wygodne-zakupy-przez-internet"
                  @click="sendAllegroAnalytics('O nas')"
                >O nas</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/reklama"
                  @click="sendAllegroAnalytics('Reklama')"
                >Reklama</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://ads.allegro.pl/"
                  @click="sendAllegroAnalytics('Allegro Ads')"
                >Allegro Ads</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://developer.allegro.pl/"
                  @click="sendAllegroAnalytics('Allegro API')"
                >Allegro API</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/praca"
                  @click="sendAllegroAnalytics('Praca w Allegro')"
                >Praca w Allegro</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://raportcsr.allegro.pl/"
                  @click="sendAllegroAnalytics('Społeczna odpowiedzialność')"
                >Społeczna odpowiedzialność</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/mapa-strony/kategorie"
                  @click="sendAllegroAnalytics('Mapa strony')"
                >Mapa strony</a>
              </li>
            </ul>
          </div>
          <div class="box">
            <h3>Centrum pomocy</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/pomoc"
                  @click="sendAllegroAnalytics('Pomoc')"
                >Pomoc</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://dlakupujacych.allegro.pl/"
                  @click="sendAllegroAnalytics('Dla kupujących')"
                >Dla kupujących</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/dla-sprzedajacych"
                  @click="sendAllegroAnalytics('Dla sprzedających')"
                >Dla sprzedających</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/regulaminy/polityka-plikow-cookies-lDzYv9wn8Tn"
                  @click="sendAllegroAnalytics('Polityka plików cookies')"
                >Polityka plików "cookies"</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/regulamin/pl"
                  @click="sendAllegroAnalytics('Regulamin')"
                >Regulamin</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/regulaminy/dopasowanie-reklam-mGEVAZaXoc3"
                  @click="sendAllegroAnalytics('Dopasowanie reklam')"
                >Dopasowanie reklam</a>
              </li>
            </ul>
          </div>
          <div class="box">
            <h3>Serwisy</h3>
            <ul>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/smart"
                  @click="sendAllegroAnalytics('Allegro Smart!')"
                >Allegro Smart!</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/strefamarek"
                  @click="sendAllegroAnalytics('Strefa marek')"
                >Strefa marek</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/artykuly"
                  @click="sendAllegroAnalytics('Artykuły')"
                >Artykuły</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://archiwum.allegro.pl/"
                  @click="sendAllegroAnalytics('Archiwum Allegro')"
                >Archiwum Allegro</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/monety"
                  @click="sendAllegroAnalytics('Monety Allegro')"
                >Monety Allegro</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegro.pl/karty-podarunkowe"
                  @click="sendAllegroAnalytics('Karty podarunkowe Allegro')"
                >Karty podarunkowe Allegro</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://allegrolokalnie.pl/"
                  @click="sendAllegroAnalytics('Allegro Lokalnie')"
                >Allegro Lokalnie</a>
              </li>
            </ul>
          </div>
          <div class="box box-social">
              <a target="_blank" rel="noopener noreferrer" class="social-wide" href="https://allegro.pl/app"><img src="@/assets/images/f-appstore.svg" alt="" /></a>
              <a target="_blank" rel="noopener noreferrer" class="social-wide" href="https://allegro.pl/app"><img src="@/assets/images/f-gplay.svg" alt="" /></a>
              <div class="social-row">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/allegro"><img src="@/assets/images/f-face.svg" alt="" /></a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/allegro-pl"><img src="@/assets/images/f-in.svg" alt="" /></a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/allegropl"><img src="@/assets/images/f-insta.svg" alt="" /></a>
              </div>
              <div class="social-row">
                <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.com/allegropl"><img src="@/assets/images/f-pinterest.svg" alt="" /></a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/allegro"><img src="@/assets/images/f-youtube.svg" alt="" /></a>
                <a target="_blank" rel="noopener noreferrer" href="https://charytatywni.allegro.pl/"><img src="@/assets/images/f-charytatywni.svg" alt="" /></a>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="content-wrapper">
        <p>
          Korzystanie z serwisu oznacza akceptację
          <a
            target="_blank"
            href="https://allegro.pl/regulamin/pl"
          >regulaminu</a>
        </p>
        <a href="https://allegro.pl">
          <img
            class="allegro-logo-white"
            src="@/assets/images/logo_allegro_white.png"
            alt="Allegro"
          />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    sendWospAnalytics: function(linkName) {
    //   ga("send", "event", "stopka wosp", "text click", linkName);
    },
    sendAllegroAnalytics: function(linkName) {
    //   ga("send", "event", "stopka allegro", "text click", linkName);
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";

footer {
  .footer-top {
    background: #fff;

    .top__top,
    .top__bottom {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 35px 0 20px;

      .box {
        width: 25%;
        padding-right: 5%;
        color: $footerTopText;
        
        &.box-social {
            display: flex;
            flex-direction: column;

            @media only screen and (max-width: 480px) {
              align-items: center;
            }
        }

        @media only screen and (max-width: 991px) {
          width: 50%;

          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 20px;
          }
        }

        @media only screen and (max-width: 480px) {
          width: 100%;
          text-align: center;
          padding-right: 0px;

          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 0px;
          }
        }
        
        .social-wide {
          max-width: 108px;
          margin-bottom: 10px;

          img {
            @media only screen and (max-width: 480px) {
              height: 30px;
            }
          }
        }

        .social-row {
          display: flex;
          flex-direction: row;
          margin-bottom: 5px;

          a {
            margin-right: 10px;

            @media only screen and (max-width: 480px) {
              margin-left: 5px;
              margin-right: 5px;
            }

            img {
              width: 40px;
            }
          }
        }

        h3 {
          font-size: 20px;
          line-height: 27px;
          min-height: calc(27px * 2);
          font-weight: 700;
          color: $footerTopText;
          margin-bottom: 24px;

          @media only screen and (max-width: 480px) {
            min-height: auto;
            margin-top: 15px;
          }
        }

        ul {
          list-style: none;

          li {
            margin-bottom: 15px;
            font-size: 14px;

            strong {
              font-weight: 600;
            }

            a {
              color: $footerTopText;
              text-decoration: none;
              font-weight: 600;

              &:hover {
                color: lighten($footerTopText, 30%);
              }
            }
          }
        }
      }
    }

    .top__top {
      border-bottom: 2px rgba(128, 128, 128, 0.2) solid;
    }

    .top__bottom {
    }
  }

  .footer-bottom {
    height: 90px;
    background: $footerBackground;

    @media only screen and (max-width: 768px) {
      height: auto;
      padding: 12px 0;
      text-align: center;
    }

    .content-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;

      @media only screen and (max-width: 768px) {
        flex-direction: column;
      }

      p {
        color: #fff;
        font-size: 14px;
        line-height: 22px;

        a {
          color: $footerLink;
          text-decoration: none;
        }
      }

      .allegro-logo-white {
        height: 40px;

        @media only screen and (max-width: 768px) {
          margin-top: 14px;
        }
      }
    }
  }
}
</style>